/**
 * Detect fn
 */
export default () => 'assign' in Object
